import {
  processTemplateVariables,
  hasTemplateVariables,
} from "./template-converter";

class QuickwordProcessor {
  /**
   * Check if text contains template variables
   */
  hasTemplateVariables(text) {
    return hasTemplateVariables(text);
  }

  /**
   * Check if text contains temperature-related template variables
   */
  hasTemperatureVariables(text) {
    if (!text) return false;
    const tempRegex = /\$\{[^}]*temperature[^}]*\}/i;
    return tempRegex.test(text);
  }

  processQuickword(quickwordText, scopePreference = null) {
    if (!quickwordText) return quickwordText;

    // Check if we need to process template variables
    if (!this.hasTemplateVariables(quickwordText)) {
      return quickwordText;
    }

    // Check if we need scope preference (only for temperature variables)
    if (this.hasTemperatureVariables(quickwordText)) {
      if (!scopePreference) {
        console.warn(
          "Temperature variables detected but no scope preference provided"
        );
      }
      return processTemplateVariables(quickwordText, scopePreference);
    } else {
      // No temperature variables, process without scope preference
      return processTemplateVariables(quickwordText, null);
    }
  }

  /**
   * Process quickword synchronously (for non-temperature variables only)
   * @param {string} quickwordText - The quickword text to process
   * @returns {string} - Processed quickword text
   */
  processQuickwordSync(quickwordText) {
    if (!quickwordText || !this.hasTemplateVariables(quickwordText)) {
      return quickwordText;
    }

    // Only process if there are no temperature variables
    if (this.hasTemperatureVariables(quickwordText)) {
      throw new Error(
        "Cannot process temperature variables synchronously. Use processQuickword() instead."
      );
    }

    return processTemplateVariables(quickwordText, null);
  }

  /**
   * Check if quickword can be processed synchronously
   * @param {string} quickwordText - The quickword text to check
   * @returns {boolean} - True if can be processed synchronously
   */
  canProcessSync(quickwordText) {
    if (!quickwordText || !this.hasTemplateVariables(quickwordText)) {
      return true; // No template variables, always sync
    }

    return !this.hasTemperatureVariables(quickwordText);
  }
}

// Create a singleton instance
const quickwordProcessor = new QuickwordProcessor();

// Export both the class and singleton instance
export { QuickwordProcessor };
export default quickwordProcessor;
